module.exports = __webpack_public_path__ + "images/hypothesis-test2-10.webp";